module.exports = __webpack_public_path__ + "weixin/img/foreigner-back.a036054e.png";